import { ARInvoice } from '@melio/ar-domain';
import { ActionsDropdownMenuItemProps, Table, TableColumnDef } from '@melio/penny';

import {
  getActionLabel,
  getActionParameterValue,
  getActionVariant,
  getInvoiceAction,
  getInvoiceStatusActions,
  InvoiceActionsHandlers,
} from '../../../../utils';

type InvoiceActionCellProps = {
  row: ARInvoice;
  meta: InvoiceActionsHandlers;
};

const handleCellClick = (e: React.MouseEvent<HTMLDivElement>) => {
  e.stopPropagation();
};

export const InvoiceActionCell = ({ row: invoice, meta }: InvoiceActionCellProps) => {
  const actions = getInvoiceStatusActions(invoice.displayStatus);
  if (actions.length == 0) {
    return null;
  }

  const actionItems = actions
    .map((action) => {
      const actionFn = getInvoiceAction(action, meta);
      const actionParameterValue = getActionParameterValue({ action, invoice });

      return actionFn
        ? {
            label: getActionLabel(action),
            variant: getActionVariant(action),
            onClick: () => void actionFn(actionParameterValue),
          }
        : null;
    })
    .filter(Boolean) as ActionsDropdownMenuItemProps[];

  return (
    <Table.Cell onClick={handleCellClick}>
      <Table.ActionsCell options={actionItems} data-testid={`invoice-actions-cell-${invoice.id}`} />
    </Table.Cell>
  );
};

export const ActionsCell: TableColumnDef<ARInvoice, InvoiceActionsHandlers> = {
  id: 'action',
  cell: ({ row, meta }) => (meta ? <InvoiceActionCell row={row} meta={meta} /> : null),
  size: 'xs',
};
